categories = [
  'analytics-reporting'
  'automation'
  'board-utilities'
  'communication-collaboration'
  'developer-tools'
  'file-management'
  'hr-operations'
  'it-project-management'
  'marketing-social-media'
  'product-design'
  'sales-support'
]

featuredPlugins = {
  '586be36326cc4c7e9f70beb3': require('images/directory/featured-hero/Jira.jpg')
  '55a5d917446f51777421000a': require('images/directory/featured-hero/slack.jpg')
  '588a331cc86ffbe08f5d2c67': require('images/directory/featured-hero/bitbucket.jpg')
  '55a5d916446f517774210006': require('images/directory/featured-hero/googleDrive.jpg')
  '58bd1f9aca72f48c8900574f': require('images/directory/featured-hero/planyway.jpg')
  '58d4259b89d6d7e47a899239': require('images/directory/featured-hero/zapier.jpg')
}

featuredCarouselData = [
  {
    title: 'Customize Your Cards'
    body: 'Organize the information you need the way you want with the Custom Fields Power-Up.'
    image: require('images/directory/carousel/customize.png')
    link: 'https://blog.trello.com/trello-custom-fields'
  }
  {
    title: 'Go-To-Market With Gusto'
    body: 'Maximize marketing team collaboration with these six Power-Ups.'
    image: require('images/directory/carousel/gusto.png')
    link: 'https://blog.trello.com/go-to-market-strategy-in-trello'
  }
  {
    title: 'Go From Idea To MVP'
    body: 'A five Power-Up lineup to get your team to launch day faster.'
    image: require('images/directory/carousel/mvp.png')
    link: 'https://blog.trello.com/idea-to-mvp-product-workflow-trello-power-ups'
  }
]

module.exports = {
  categories
  featuredPlugins
  featuredCarouselData
}



// WEBPACK FOOTER //
// ./app/scripts/data/directory.coffee